import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import { useMemo } from 'react';
import { styleSheet } from '../styles';

type Props = {
	contact: Api.IContact;
};

export const LastInteractionInfo = ({ contact }: Props) => {
	const lastInteractionMoment = useMemo(() => {
		if (!contact.relationshipHealth?.lastInteractionDate) {
			return null;
		}

		return moment(contact.relationshipHealth.lastInteractionDate);
	}, [contact]);

	const lastInteractionInDays = useMemo(() => {
		if (!lastInteractionMoment) {
			return -1;
		}

		return moment().diff(lastInteractionMoment, 'day');
	}, [lastInteractionMoment]);

	const lastInteractionStyleClass = useMemo(() => {
		const status = contact.relationshipHealth?.status;
		if (status === 'Healthy') {
			return styleSheet.lastInteractionTextHealthy;
		}

		if (status === 'Unhealthy') {
			return styleSheet.lastInteractionTextUnhealthy;
		}

		return styleSheet.lastInteractionTextNeutral;
	}, [contact]);

	if (!contact || !contact.relationshipHealth) {
		return null;
	}

	if (!lastInteractionMoment) {
		return null;
	}

	if (lastInteractionInDays > 0) {
		return (
			<div className={css(styleSheet.lastInteractionText, lastInteractionStyleClass)}>
				<div className='indicator' />
				Last Interaction - {`${lastInteractionInDays} day${lastInteractionInDays > 1 ? 's' : ''} ago`}
			</div>
		);
	}

	return (
		<div className={css(styleSheet.lastInteractionText, lastInteractionStyleClass)}>
			<div className='indicator' />
			Last Interaction within a day
		</div>
	);
};
